module.exports = __webpack_public_path__ + "icons/original/large/large-e4.07420566e5a63e3313fa48704100c22f.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-e4.png
// module id = SAo3
// module chunks = app